<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('visitation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('visitation.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3">
            <ts-input
              v-model="search"
              v-tooltip="$t('visitation.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <!-- <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('customerProfile.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter> -->
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
         <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.plan_date }}</td>
          <td>{{ record.user.name }}</td>
          <td class="ts-space-x-3">
						<p
							v-for="(cus, index) in record.customer_list"
							:key="index"
							class="ts-px-2 ts-border ts-border-gray-200 ts-rounded ts-float-left ts-mb-1"
						>
							{{ cus.customer_name }}
						</p>
					</td>
          <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.visit_status">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="text-center ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <!-- <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm> -->
          </td>
        </template>
      </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('visitation.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
				:maskClosable="false"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'customerProfileIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('customer/visitation', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.customer.visitation.search
      },
      set(newValue) {
        this.$store.commit('customer/visitation/SET_SEARCH', newValue)
        this.$store.commit('customer/visitation/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('visitation.date') },
        { name: this.$t('visitation.saleName') },
        { name: this.$t('visitation.customer') },
        { name: this.$t('visitation.status'), style: 'text-align:center;' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    },
		dateRange: {
      get() {
        return this.$store.state.customer.visitation.dateRange
      },
      set(newValue) {
        this.$store.commit('customer/visitation/SET_DATE_RANGE', newValue)
      },
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('customer/visitation/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('customer/visitation/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
      this.$store.commit('customer/visitation/SET_EDIT_DATA', {})
      this.showForm = false
			this.fetchData()
		},
		// deleteRecord(record) {
    //   record._deleting = true
    //   this.$store
    //     .dispatch('customer/visitation/destroy', record.customer_id)
    //     .then(response => {
    //       this.$toasted.success(response.message)
    //       this.fetchData()
    //     })
    //     .catch(error => {
    //       this.$toasted.error(error.message)
    //     })
    //     .finally(() => {
    //       record._deleting = false
    //     })
    // },
    // branchFilter(value){
    //   this.$store.commit('customer/visitation/SET_BRANCH_ID', value)
    //   this.fetchData()
    // }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('customer/visitation/RESET_STATE')
    next()
  }
}
</script>
